import React from "react"

export * from "./store"
export * from "./store/AuthSlice"
export { default as AuthReducer } from "./store/AuthSlice"
export const Login = React.lazy(() => import("./Login"));